export const RomeFontana = [
  'https://c1.hiqcdn.com/customcdn/1300x512/destreviewimages/shareiq_1757_1487758792.999752.jpg',
  'http://www.gliscritti.it/gallery3/var/albums/album_066/bernini%20fontana%20051.jpg',
  'https://www.italyguides.it/images/lazio/roma/blog/quattrofiumi_2.jpg',
  'https://2.bp.blogspot.com/-LQzyqhbooiU/VkOKx1ms3OI/AAAAAAAFEps/A9CNTfXmHzE/s1600/The%2BFountain%2Bof%2Bthe%2BFour%2BRivers%2BRome%2B%25282%2529.jpg',
  'http://www.tropicalisland.de/italy/rome/piazza_navona/images/FCO%20Rome%20-%20Piazza%20Navona%20with%20Berninis%20masterpiece%20Fontana%20dei%20Quattro%20Fiumi%20fountain%2003%203008x2000.jpg',
];

export default [
  {
    name: 'Rome Fontana dei Quattro Fiumi',
    slider: true,
    images: RomeFontana,
  },
  {
    name: 'The Martyrdom of St Januarius in the Amphitheatre at Pozzuoli',
    slider: false,
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/The_Martyrdom_of_St_Januarius_in_the_Amphitheatre_at_Pozzuoli.jpg/300px-The_Martyrdom_of_St_Januarius_in_the_Amphitheatre_at_Pozzuoli.jpg',
  },
  {
    name: 'The Entombment of Christ',
    slider: false,
    image: 'https://upload.wikimedia.org/wikipedia/commons/a/ab/Caravaggio_-_La_Deposizione_di_Cristo.jpg',
  },
];
